module.exports = __webpack_public_path__ + "img/24000.a65d6f38.jpg";